import React, { Component } from "react";
import { connect } from 'react-redux';
import { Table } from "react-bootstrap";

class GuncelKur extends Component {
    render() {
        const { guncelKur } = this.props;

        return (
            <div>
                <Table responsive striped bordered condensed hover>
                    <tbody>
                        {guncelKur.map((each, i) => {
                            return ((each.KaynakParaBirimiAd === "EURO") ? (
                                <tr key={i}>
                                    <td>
                                        <div id="euFlag"></div>
                                    </td>
                                    <td>
                                        <i className="fa fa-euro" />
                                        <i className="fa">{each.CaprazKurHedefBirim}</i>
                                    </td>
                                </tr>
                            ) :
                                (
                                    <tr key={i}>
                                        <td>
                                            <div id="usaFlag"></div>
                                        </td>
                                        <td>
                                            <i className="fa fa-usd" />
                                            <i className="fa">{each.CaprazKurHedefBirim}</i>
                                        </td>
                                    </tr>
                                )
                            )
                        })}
                    </tbody>
                </Table>
            </div >
        );
    }
}

const mapStateToProp = state => ({
    guncelKur: state.reducer.guncelKur
});

export default connect(mapStateToProp)(GuncelKur);


// WEBPACK FOOTER //
// ./src/components/containers/GuncelKur.js